import {createFileRoute, useNavigate} from "@tanstack/react-router"
import {Comparator, invertComparator} from "../../../util/arutil.tsx";
import {BundleActor, dispatchBundleAscSorters} from "../../../bundle/timeline.tsx";
import {useCallback, useMemo} from "react";
import {SortOrder} from "../../../rpc/webrpc-client.gen.ts";
import {useDispatchBundleActors} from "../../../dispatch/dispatch.tsx";
import {TileSpread} from "../../../components/Tile.tsx";
import {DispatchBundleTile} from "../../../dispatch/DispatchBundleTile.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {
    DispatchOverviewSettings,
    validateDispatchOverviewSettings
} from "../../../dispatch/dispatchOverviewSettings.tsx";
import {DispatchFacetEntity, dispatchFacetIcons} from "../../../dispatch/dispatchFacet.tsx";
import {tieredActiveIcons} from "../../../fa.tsx";
import {IconToggleSwitch, ToggleBar} from "../../../components/ToggleBar.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";
import {TieredOrActive} from "../../../dispatch/tieredOrActive.tsx";
import {Stack} from "@mui/joy";

function DispatchBundleSpread() {
    const {order, sortOrder}: DispatchOverviewSettings = Route.useSearch();
    const cmp: Comparator<BundleActor> = useMemo(() => {
        let rv = dispatchBundleAscSorters[order];
        if (sortOrder === SortOrder.enum.DESC) {
            rv = invertComparator(rv);
        }
        return rv;
    }, [order, sortOrder]);
    const unsortedDxbsTqrv = useDispatchBundleActors();
    const sortedDxbs = useMemo(() => {
        const rv = (unsortedDxbsTqrv.data ?? []).toSorted(cmp);
        return rv;
    }, [cmp, unsortedDxbsTqrv.data]);

    // // you can't really write a query function here, so useQuery won't work
    // const [dxbs, setDxbs] = useState<Touchable<DispatchBundle>[] | undefined>();
    // const tqc = useQueryClient();
    // const tqk = order === "active"
    //     ? dispatchBundlesActiveOrderTqk
    //     : dispatchBundlesStableOrderTqk;
    // useEffect(() => {
    //     const tqwatcher = new QueryObserver<RefStableArray<Touchable<DispatchBundle>>>(tqc, {queryKey: tqk});
    //     const unsubscribe = tqwatcher.subscribe(({data: next}) => {
    //         setDxbs(next?.items);
    //     });
    //
    //     return unsubscribe;
    // }, [tqc, tqk]);

    return <TileSpread foods={sortedDxbs} Component={({food: dxb}) => {
        return <DispatchBundleTile dxb={dxb}/>;
    }} estimatedHeight={180}/>
}

function DispatchBundlePage() {
    const navigate = useNavigate();
    const search = Route.useSearch();
    const bomb = useBomb();
    const setFacet = useCallback((next: DispatchFacetEntity) => {
        navigate({to: `/dispatch/${next}`, search}).catch(bomb);
    }, [bomb, navigate, search]);
    const order = search.order;
    const setOrder = useCallback((next: TieredOrActive) => {
        navigate({to: Route.to, params: {facet: "bundle"}, search: {...search, order: next}}).catch(bomb);
    }, [bomb, navigate, search]);
    const sortOrder = search.sortOrder;
    const setSortOrder = useCallback((next: SortOrder) => {
        navigate({to: Route.to, params: {facet: "bundle"}, search: {...search, sortOrder: next}}).catch(bomb);
    }, [bomb, navigate, search]);

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
                <ToggleBar>
                    <IconToggleSwitch dispatchValue={setOrder} icons={tieredActiveIcons} value={order}/>
                    <IconToggleSwitch dispatchValue={setFacet} icons={dispatchFacetIcons} value="bundle"/>
                    <IconToggleSwitch dispatchValue={setSortOrder} icons={sortOrderIcons} value={sortOrder}/>
                </ToggleBar>
            </Stack>
        </PageHeader>
        <PageBody>
            <DispatchBundleSpread/>
        </PageBody>
    </PageShell>;
}


export const Route = createFileRoute("/_auth/dispatch/bundle")({
    component: DispatchBundlePage,
    // params: {
    //     parse: (raw: Record<string, unknown>) => {
    //         const rv = DispatchSearchParams.parse(raw);
    //         return rv;
    //     },
    // },
    validateSearch: validateDispatchOverviewSettings,
});
